/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import AbstractMaterial from "App/geometry/material/abstract_material";

export default
class Factory {
    private static UID: number = -1;
    private static registeredObjects: any = {};

    constructor() {
        //
    }

    public static register(aClass: any): void
    {
        Factory.registeredObjects[aClass.TypeName] = aClass;
    }

    public static create(aTypeName: string, aHash: string): AbstractMaterial
    {
        let object = Factory.registeredObjects[aTypeName].create();
        object._UID = ++Factory.UID;
        object._hashKey = aHash;
        object._classTypeName = aTypeName;
        return object;
    }
}
